import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'acabim-admin-assign-project-groups',
  templateUrl: './assign-project-groups.component.html',
  styleUrls: ['../styles.scss', './assign-project-groups.component.scss']
})
export class AssignProjectGroupsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
